import { renderToString } from "react-dom/server";
/**
 * Removes the content from the live region.
 */

export const clearAnnouncement = _ref => {
  let {
    ref,
    onAnnouncementClear
  } = _ref;

  if (ref.current) {
    ref.current.innerHTML = "";
  }

  onAnnouncementClear && onAnnouncementClear();
};
/**
 * Announce the content of "children".
 */

export const announce = _ref2 => {
  let {
    children,
    ref,
    clearAnnouncementDelay,
    clearAnnouncementTimeout,
    onAnnouncementClear
  } = _ref2;
  clearTimeout(clearAnnouncementTimeout.current);

  if (children !== null && ref.current) {
    ref.current.innerHTML = renderToString(children);
  }

  if (clearAnnouncementDelay) {
    clearAnnouncementTimeout.current = setTimeout(clearAnnouncement, clearAnnouncementDelay, {
      ref,
      onAnnouncementClear
    });
  }
};
/**
 * Inserts the content into the live region with some
 * delay if the announcementDelay prop is supplied.
 * Otherwise inserts the content immediately.
 */

export const conditionallyDelayAnnouncement = _ref3 => {
  let {
    children,
    ref,
    announcementTimeout,
    announcementDelay,
    clearAnnouncementDelay,
    clearAnnouncementTimeout,
    onAnnouncementClear
  } = _ref3;
  clearTimeout(announcementTimeout.current);

  if (announcementDelay) {
    announcementTimeout.current = setTimeout(announce, announcementDelay, {
      children,
      ref,
      clearAnnouncementDelay,
      clearAnnouncementTimeout,
      onAnnouncementClear
    });
  } else {
    announce({
      children,
      ref,
      clearAnnouncementDelay,
      clearAnnouncementTimeout,
      onAnnouncementClear
    });
  }
};